<template>
  <base-modal-bottom
    ref="modal"
    class="modal-withdraw-order-blocked-per-minutes has-text-centered"
    :isFooter="true"
    :title="title"
    :withClickOverlay="false"
    :btnClose="false"
  >
    <div class="margin-bottom">
      <base-icon width="64" height="64" name="time-info" />
    </div>

    <div class="margin-bottom title-message">
      <p>
        <strong>Solicitação de saque não realizada</strong>
      </p>
    </div>

    <p class="subtitle-message">
      Parece que tivemos um problema ao tentar executar o seu saque. Por favor,
      aguarde 5 minutos e tente novamente.
    </p>
    <template #footer>
      <base-button-bottom
        @click.native="close"
        class="is-primary is-big"
        type="button"
      >
        Ok, entendi!
      </base-button-bottom>
    </template>
  </base-modal-bottom>
</template>

<script>
import BaseModalBottom from '@/components/BaseModalBottom.vue'
import BaseButtonBottom from '@/components/BaseButtonBottom.vue'

export default {
  components: {
    BaseModalBottom,
    BaseButtonBottom,
  },

  props: {
    title: {
      type: String,
      default: 'Oops, algo deu errado!',
    },
  },

  methods: {
    open() {
      this.$refs.modal.open()
    },
    close() {
      this.$refs.modal.close()
      this.$emit('onClose')
    },
  },
}
</script>

<style lang="scss">
.modal-withdraw-order-blocked-per-minutes {
  .title-message,
  .subtitle-message,
  strong {
    max-width: 429px;
    margin: 0 auto;
    font-size: 16px;
    color: $neutral;
  }
}
</style>
